export default __webpack_public_path__ + "static/media/close.fa197366.svg";